// extracted by mini-css-extract-plugin
module.exports = {"selectedSymbolContainer":"styles_selectedSymbolContainer__3KdHH"};